module.exports = __webpack_public_path__ + "img/NOMBREBLANCO.3f8758e1.png";